import { createAsyncThunk } from '@reduxjs/toolkit';
import { MerchantState, MerchantProps, DeleteMerchantProps } from './types';
import ApiService from 'services/ApiService';

export const getMerchantList = createAsyncThunk(
  'merchant/list',
  async ({ search, page_no, page_size, sort_by, sort_direction, token }: MerchantProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant?page_no=${page_no ? page_no : 10
        }&page_size=${page_size ? page_size : 1}&sort_by=${sort_by ? sort_by : 'name'
        }&sort_direction=${sort_direction ? sort_direction : 'asc'}${search ? `&search=${search}` : ''
        }`,
        config,
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: 'success',
          error: null,
        } as unknown as MerchantState;
      } else {
        return {
          data: response.data?.message,
          status: 'empty',
          error: null,
        } as unknown as MerchantState;
      }
    } catch (err) {
      if (err)
        return {
          data: 'Something went wrong!',
          status: 'error',
          error: err,
        } as unknown as MerchantState;
    }
  },
);

export const deleteMerchant = createAsyncThunk(
  'merchant/delete',
  async ({ merchant_id, token }: DeleteMerchantProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${merchant_id}`,
        config,
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: 'success',
          error: null,
        } as unknown as MerchantState;
      } else {
        return {
          data: response.data?.message,
          status: 'empty',
          error: null,
        } as unknown as MerchantState;
      }
    } catch (err) {
      return {
        data: 'Something went wrong!',
        status: 'error',
        error: err,
      } as unknown as MerchantState;
    }
  },
);

export const createMerchant = createAsyncThunk(
  'merchant/create',
  async ({
    businessId,
    businessOwnerName,
    businessName,
    descriptionStore,
    whatsappApiToken,
    merchantCode,
    email,
    catalogId,
    phoneNumberId,
    phoneNumber,
    address,
    foto,
    icon,
    isIntegerateWithAssistant,
    taxFee,
    serviceFee,
    serviceFeeType,
    balance,
    taxType,
    areaId,
    provinceId,
    cityId,
    lat,
    lng,
    suburbId,
    appId,
    resellerOnly,
    token,
    aiPrompt,
    aiPromptCustom,
    configurationData,
    postalCode,
    affiliatePlatformFee,
    whatsappNumber
  }: any) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.post(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant`,
        {
          businessId,
          businessOwnerName,
          businessName,
          descriptionStore,
          whatsappApiToken,
          merchantCode,
          email,
          catalogId,
          phoneNumberId,
          phoneNumber,
          address,
          foto,
          icon,
          isIntegerateWithAssistant,
          taxFee,
          serviceFee,
          serviceFeeType,
          balance,
          taxType,
          areaId,
          provinceId,
          cityId,
          lat,
          lng,
          suburbId,
          appId,
          resellerOnly,
          aiPrompt,
          aiPromptCustom,
          configurationData: {
            penjualanRetail: configurationData?.penjualanRetail ?? false,
            penjualanJasa: configurationData?.penjualanJasa ?? false,
            trackingNotificationMerchant: configurationData?.trackingNotificationMerchant ?? false,
            trackingNotificationCustomer: configurationData?.trackingNotificationCustomer ?? false,
            receiptNotification: configurationData?.receiptNotification ?? false,
            affiliateProgram: configurationData?.affiliateProgram ?? false,
            affiliateCommission: configurationData?.affiliateCommission ?? 0,
            affiliateWhatsappNumber: configurationData?.affiliateWhatsappNumber ?? '',
            isChatOnly: configurationData?.isChatOnly ?? false,
            websiteBanner: configurationData?.websiteBanner ?? '',
            websiteTitle: configurationData?.websiteTitle ?? '',
            websiteDescription: configurationData?.websiteDescription ?? '',
          },
          affiliatePlatformFee,
          postalCode: Number(postalCode),
          whatsappNumber
        },
        config,
      );

      if (response && response.data) {
        console.log('data create merchant', response.data);
        return {
          data: response.data,
          status: 'success',
          error: null,
        } as unknown as MerchantState;
      } else {
        return {
          data: response.data?.message,
          status: 'empty',
          error: null,
        } as unknown as MerchantState;
      }
    } catch (err) {
      return {
        data: 'Something went wrong!',
        status: 'error',
        error: err,
      } as unknown as MerchantState;
    }
  },
);

export const editMerchant = createAsyncThunk(
  'merchant/edit',
  async ({
    businessId,
    businessOwnerName,
    businessName,
    descriptionStore,
    whatsappApiToken,
    merchantCode,
    email,
    catalogId,
    phoneNumberId,
    phoneNumber,
    address,
    foto,
    icon,
    isIntegerateWithAssistant,
    taxFee,
    serviceFee,
    serviceFeeType,
    balance,
    taxType,
    areaId,
    provinceId,
    cityId,
    lat,
    lng,
    suburbId,
    appId,
    resellerOnly,
    token,
    aiPrompt,
    idBusiness,
    aiPromptCustom,
    configurationData,
    postalCode,
    affiliatePlatformFee,
    whatsappNumber
  }: any) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const payload = {
        businessId,
        businessOwnerName,
        businessName,
        descriptionStore,
        whatsappApiToken,
        merchantCode,
        email,
        catalogId,
        phoneNumberId,
        phoneNumber,
        address,
        foto,
        icon,
        isIntegerateWithAssistant,
        taxFee,
        serviceFee,
        serviceFeeType,
        balance,
        taxType,
        areaId,
        provinceId,
        cityId,
        lat,
        lng,
        suburbId,
        appId,
        resellerOnly,
        aiPrompt,
        aiPromptCustom,
        configurationData: {
          penjualanRetail: configurationData?.penjualanRetail ?? false,
          penjualanJasa: configurationData?.penjualanJasa ?? false,
          trackingNotificationMerchant: configurationData?.trackingNotificationMerchant ?? false,
          trackingNotificationCustomer: configurationData?.trackingNotificationCustomer ?? false,
          receiptNotification: configurationData?.receiptNotification ?? false,
          affiliateProgram: configurationData?.affiliateProgram ?? false,
          affiliateCommission: configurationData?.affiliateCommission ?? 0,
          affiliateWhatsappNumber: configurationData?.affiliateWhatsappNumber ?? '',
          isChatOnly: configurationData?.isChatOnly ?? false,
          websiteBanner: configurationData?.websiteBanner ?? '',
          websiteTitle: configurationData?.websiteTitle ?? '',
          websiteDescription: configurationData?.websiteDescription ?? '',
        },
        postalCode,
        affiliatePlatformFee,
        whatsappNumber
      };
      console.log('edit merchant payload', payload);
      const response = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}`,
        payload,
        config,
      );

      if (response && response.data) {
        console.log('data edit merchant', response.data);
        return {
          data: response.data,
          status: 'success',
          error: null,
        } as unknown as MerchantState;
      } else {
        return {
          data: response.data?.message,
          status: 'empty',
          error: null,
        } as unknown as MerchantState;
      }
    } catch (err) {
      return {
        data: 'Something went wrong!',
        status: 'error',
        error: err,
      } as unknown as MerchantState;
    }
  },
);


export const editConfigurationData = createAsyncThunk(
  'merchant/editConfiguration',
  async (
    {
      penjualanRetail,
      penjualanJasa,
      token,
      idBusiness
    }: {
      penjualanRetail?: boolean; 
      penjualanJasa?: boolean;
      token: string;
      idBusiness: number;
    }
  ) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // Make a call to the new 'configuration' endpoint
      const response = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        {
          penjualanRetail,     
          penjualanJasa,       // Include other configuration fields as needed
        },
        config,
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: 'success',
          error: null,
        };
      } else {
        return {
          data: response.data?.message || 'No response message',
          status: 'empty',
          error: null,
        };
      }
    } catch (err) {
      return {
        data: 'Something went wrong!',
        status: 'error',
        error: err,
      };
    }
  },
);

export const fetchConfigurationData = createAsyncThunk(
  'merchant/fetchConfiguration',
  async (
    {
      penjualanRetail,
      penjualanJasa,
      token,
      idBusiness
    }: {
      penjualanRetail?: boolean; 
      penjualanJasa?: boolean;
      token: string;
      idBusiness: number;
    }
  ) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        config,
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: 'success',
          error: null,
        };
      } else {
        return {
          data: response.data?.message || 'No response message',
          status: 'empty',
          error: null,
        };
      }
    } catch (err) {
      return {
        data: 'Something went wrong!',
        status: 'error',
        error: err,
      };
    }
  },
);

export const toggleWaAiStatus = createAsyncThunk(
  'merchant/toggleWaAiStatus',
  async ({ merchant, isActive, token }: { merchant: any; isActive: boolean; token: string }) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      
      // Send the full merchant payload to avoid nulling out other fields
      const payload = {
        ...merchant,
        configurationData: merchant.configuration,
        isIntegerateWithAssistant: isActive,
      };

      const response = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${merchant.id}`,
        payload,
        config,
      );
      if (response && response.data) {
        return { data: response.data, status: 'success', error: null };
      }
      return { data: null, status: 'empty', error: null };
    } catch (err) {
      return { data: 'Something went wrong!', status: 'error', error: err };
    }
  },
);

export const updateDeliveryTourStatus = createAsyncThunk(
  'merchant/updateDeliveryTourStatus',
  async ({
    idBusiness,
    token,
    isDeliveryTourSeen,
    deliveryTourStep,
  }: {
    idBusiness: number;
    token: string;
    isDeliveryTourSeen?: boolean;
    deliveryTourStep?: number;
  }) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };

      // 1. Fetch current configuration so we don't overwrite other fields
      const getResponse = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        config,
      );

      const currentConfig = getResponse?.data ?? {};

      // 2. Merge — only patch the delivery tour fields
      const mergedConfig = {
        ...currentConfig,
        ...(isDeliveryTourSeen !== undefined && { isDeliveryTourSeen }),
        ...(deliveryTourStep !== undefined && { deliveryTourStep }),
      };

      // 3. PUT the full merged object
      const putResponse = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        mergedConfig,
        config,
      );

      if (putResponse && putResponse.data) {
        return { data: putResponse.data, status: 'success', error: null };
      }
      return { data: null, status: 'empty', error: null };
    } catch (err) {
      return { data: 'Something went wrong!', status: 'error', error: err };
    }
  },
);

export const updateOnboardingStatus = createAsyncThunk(
  'merchant/updateOnboardingStatus',
  async ({
    idBusiness,
    token,
    isOnboardingCompleted,
    onboardingStep,
  }: {
    idBusiness: number;
    token: string;
    isOnboardingCompleted?: boolean;
    onboardingStep?: number;
  }) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };

      // 1. Fetch current configuration so we don't overwrite other fields
      const getResponse = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        config,
      );

      const currentConfig = getResponse?.data ?? {};

      // 2. Merge — only patch the two onboarding fields
      const mergedConfig = {
        ...currentConfig,
        ...(isOnboardingCompleted !== undefined && { isOnboardingCompleted }),
        ...(onboardingStep !== undefined && { onboardingStep }),
      };

      // 3. PUT the full merged object
      const putResponse = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        mergedConfig,
        config,
      );

      if (putResponse && putResponse.data) {
        return { data: putResponse.data, status: 'success', error: null };
      }
      return { data: null, status: 'empty', error: null };
    } catch (err) {
      return { data: 'Something went wrong!', status: 'error', error: err };
    }
  },
);

export const updateProfileTourStatus = createAsyncThunk(
  'merchant/updateProfileTourStatus',
  async ({
    idBusiness,
    token,
    isProfileTourSeen,
    profileTourStep,
  }: {
    idBusiness: number;
    token: string;
    isProfileTourSeen?: boolean;
    profileTourStep?: number;
  }) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const getResponse = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        config,
      );

      const currentConfig = getResponse?.data ?? {};

      const mergedConfig = {
        ...currentConfig,
        ...(isProfileTourSeen !== undefined && { isProfileTourSeen }),
        ...(profileTourStep !== undefined && { profileTourStep }),
      };

      const putResponse = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/merchant/${idBusiness}/configuration`,
        mergedConfig,
        config,
      );

      if (putResponse && putResponse.data) {
        return { data: putResponse.data, status: 'success', error: null };
      }
      return { data: null, status: 'empty', error: null };
    } catch (err) {
      return { data: 'Something went wrong!', status: 'error', error: err };
    }
  },
);